
<form class="mce-form-section">

    <div class="mce-form-section-title">Project Details

        <button matIconButton type="button"
                matTooltip="Issues with the project, please open a ticket quoting reference {{form().uid().value()}}. Click to copy reference to clipboard."
                [cdkCopyToClipboard]="form().uid().value()">
            <mat-icon>chat_info</mat-icon>
        </button>
    </div>

    <div class="mce-form-field-group">

        <div>
            <mat-form-field>
                <mat-label>project number</mat-label>
                <input matInput placeholder="enter a project number"
                       [formField]="form().projectNumber" />
                @for (error of form().projectNumber().errors(); track error.kind ) {
                <mat-error>  {{ error.message }} </mat-error> }

            </mat-form-field>
        </div>

        <div class="min-w-0 grow">
            <mat-form-field class="w-full">
                <mat-label>description/name</mat-label>
                <input matInput placeholder="enter project discription/name"
                       [formField]="form().projectName" />
                @for (error of form().projectName().errors(); track error.kind ) {
                <mat-error>  {{ error.message }} </mat-error> }

            </mat-form-field>
        </div>

    </div>

</form>

